import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { captureAffiliateFromUrl } from "@/lib/affiliate";
import { toast } from "sonner";

const AffiliateRedirect = () => {
  const { code = "" } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    captureAffiliateFromUrl(code);
    toast.success("Welcome — your creator's link is active");
    const t = setTimeout(() => navigate("/", { replace: true }), 400);
    return () => clearTimeout(t);
  }, [code, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center space-y-2">
        <p className="font-display text-2xl text-foreground">Taking you to WeKIT™…</p>
        <p className="text-sm text-muted-foreground">Creator link {code} applied</p>
      </div>
    </div>
  );
};

export default AffiliateRedirect;
